import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import { withSeasonCheck } from '../../../config/withSeasonCheck';
import PlayerPropsPage from '../../../components/PlayerPropsPage/PlayerPropsPage';
import mlbRoutes from '../mlbRoutes';
import seoConfig from '../../../config/seo.json';

// Labels come from the shared map in src/utils/props.js (#194, #227).
const PROP_KEYS = [
  'pitcher_strikeouts',
  'batter_hits',
  'batter_home_runs',
  'batter_stolen_bases',
];

const RELATED_MARKETS = [
  { title: 'MLB Moneylines', description: 'Find value on the winner with FairLine consensus analysis.', to: '/mlb/moneyline', label: 'View Moneylines' },
  { title: 'MLB Run Lines', description: 'Run line spread analysis powered by sharp consensus benchmarks.', to: '/mlb/spread', label: 'View Run Lines' },
  { title: 'MLB Totals', description: 'Over/under odds compared against our consensus model.', to: '/mlb/total', label: 'View Totals' },
];

const MLBPlayerProps = () => (
  <PlayerPropsPage
    sport="mlb"
    seasonKey="MLB"
    apiEndpoint="/api/v2/mlb/player-props"
    propKeys={PROP_KEYS}
    sportRoutes={mlbRoutes}
    SportIcon={SportsBaseballIcon}
    seo={seoConfig?.mlb?.playerProps || { title: 'MLB Player Props +EV Analysis | +EV Bets' }}
    relatedMarkets={RELATED_MARKETS}
  />
);

export default withSeasonCheck(MLBPlayerProps, 'MLB', 'player-props');
